/** ArollShell.tsx — product shell: header/nav, asset rail, login, workspace frame. */
export const shell = {
  /** Header nav tab, sidebar heading and sidebar aria-label. */
  'shell.projects': 'Projects',
  /** Sidebar link to the full asset list page. */
  'shell.viewAll': 'View all',
  'shell.loading': 'Loading…',
  'shell.noProjectsYet': 'No projects yet.',
  /** aria-label on the header toggle for the asset sidebar. */
  'shell.closeProjectRail': 'Close project rail',
  'shell.openProjectRail': 'Open project rail',
  'shell.settings': 'Settings',
  'shell.help': "Help",
  'shell.signOut': 'Sign out',
  /** Heading on the login card. */
  'shell.signIn': 'Sign in',
  'shell.emailLabel': 'Email',
  /** Example email address shown as the empty-field placeholder. */
  'shell.emailPlaceholder': 'you@studio.com',
  'shell.passwordLabel': 'Password',
  'shell.errorWrongCredentials': 'That email and password don’t match.',
  /** Shown when the account exists but the verification link was never clicked. */
  'shell.errorVerifyEmailFirst': 'Verify your email first. Check your inbox for the link.',
  'shell.errorSignInFailed': 'Couldn’t sign in. Try again in a moment.',
  /** Submit-button label while the sign-in request is in flight. */
  'shell.signingIn': 'Signing in',
  /** Submit-button label of the login form. */
  'shell.enter': 'Enter',
  /** Link under the login card to the signup page. */
  'shell.forgotPassword': 'Forgot your password?',
  'shell.createWorkspace': 'New here? Create a workspace',
  /** Product tagline under the login card. */
  'shell.tagline': 'Client review for video. Share a cut, get the notes, take the sign-off in writing.',
  /** Button that opens the share-with-client dialog. */
  'shell.share': 'Share',
  /** First half of "That project doesn’t exist. Back to projects." The
   *  second half ({shell.projectMissingLink}) renders as a link. */
  'shell.projectMissing': 'That project doesn’t exist.',
  'shell.projectMissingLink': 'Back to projects',
  /** Tab title and line on PictureUp's not-found page (a mistyped
   *  /aroll address). The link under it is {shell.projectMissingLink}. */
  'shell.notFoundTitle': 'Not found',
  'shell.pageMissing': 'There’s nothing at this address.',
  'shell.openingProject': 'Opening project…',
  /** Collapses the footage upload drop zone. */
  'shell.hideUploader': 'Hide uploader',
  /** Reveals the footage upload drop zone; keep the leading +. */
  'shell.addFootage': '+ Add footage',
  /** Accessible name for the B▲LLAST logo in the top bar. It is the way
   *  back to the welcome page, so it reads as home, not as the brand. */
  'shell.ballastHome': 'PictureUp home',
  /** PictureUp one world: the two tabs of a project room. "Cuts" is
   *  the review room (always there); "A-Roll" only appears once the
   *  activation is on. A-Roll is a product term, not translated. */
  'shell.tabCuts': 'Cuts',
  'shell.tabAroll': 'A-Roll',
  /** Playback project made from an A-Roll cut: "Made from A-Roll <cut>". */
  'shell.madeFrom': 'Made from',
  /** Room header action that switches the A-Roll activation on. */
  'shell.addAroll': 'Add A-Roll',
  /** Tooltip on "Add A-Roll": what A-Roll is for, in one line. */
  'shell.addArollHint':
    'Long interview or raw footage you want transcribed and drafted into a cut',
} as const;
